/**
 * @description 国家地理藏品抽奖页接口
*/
import { Toast } from "antd-mobile";
import Services from 'services';
import Library from 'library';
const {JsBridge, Platform, Util} = Library;


class Service {

    /**
    * @description 初始化接口
    * @interface 600944
    * @param { 是否显示加载loading } showLoading
    *
   */
    static getInitData = async (showLoading = true, data={}) => {
        const code = '600944'
        const userInfo = await JsBridge.getCurrentUserInfo();
        try {
            const params = {
                ...data,
                userCode: userInfo?.loginName
            }
            const ServiceModule = JsBridge.hasWebViewBridge() ? 'MainPage': 'Common'
            const res = await Services(ServiceModule, { code }, params, !showLoading);
            if (res.status > 0) {
                return { data: res.data?.result || res.data };
            } else {
                throw res.message || '请求失败'
            }
        } catch (error) {
            !JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
        }
    }

    /**
     * @description 获取奖品九宫格数据
     * @interface 600114
     * @param { 是否显示加载loading } showLoading
     *
   */
    static fetchGifts = async (showLoading = true, params = {}) => {
        const code = '600114'
        try {
            const ServiceModule = JsBridge.hasWebViewBridge() ? 'MainPage': 'Common'
            const res = await Services(ServiceModule, { code }, params, !showLoading);
            if (res.status > 0) {
                return { data: res.data?.result || res.data };
            } else {
                throw res.message || '请求失败'
            }
        } catch (error) {
            !JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
        }
    }

    /**
     * @description 抽奖接口
     * @interface 600864
     * @param {activityCode: 活动编码, reduceTimes: 抽奖次数1或10}
    */
    static lotteryGift = async (params={}) => {
        const code = '600864'
        try {
            const body = {
                ...params
            }
            
            const res = await Services('MainPage', { code }, body, true);
            if (res.status > 0) {
                return res;
            }else {
                throw res.message || '请求失败';
            }
        } catch (error) {
            !JsBridge.hasWebViewBridge() && Toast.show(error || '请求失败')
        }
    }

}

export default Service;